import styled from 'styled-components/macro';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { getTextStyles } from '@yme/utils/styles';
export const WarrantyList = styled.ul `
  margin: 24px 0 0;
  padding: 0;
  list-style: none;
`;
export const WarrantyItem = styled.li `
  display: flex;
  align-items: center;

  ${getTextStyles('Ubuntu', 400, 16, 28)}

  color: ${colorCoreBlack300};

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;
